import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showAlert, showNotification, catchHandler } from "@/utils/helpers";
import { status } from "../../utils/common";

export default {
    namespaced: true,
    state: {
        doctors: [],
        doctor: {
            name: 'احمد',
            createdBy: null,
            createdOn: null,
            status: 1,
        },

        totalItems: 0,
    },
    getters: {
        index: state => (id) => state.doctors.findIndex(i => i.id === id)
    },
    mutations: {
        SET_ITEMS: (state, data) => state.doctors = data,
        SET_TOTAL_ITEMS: (state, r) => (state.totalItems = r),
        SET_ITEM: (state, viewData) => state.doctor = viewData,
        add: (state, addedData) => state.doctors.unshift(addedData),
        UPDATE: (state, { index, updateData }) => state.doctors.splice(index, 1, updateData),
        DELETE: (state, index) => state.doctors.splice(index, 1),
     lock: (state, index) => state.doctors[index].status = status.locked,
       unlock: (state, index) => state.doctors[index].status = status.active,
      
    },
    actions: {
        async getAll({ commit }, params) {
            startLoading()
            try {
                const paramsString = Object.entries(params)
                    .filter(([, val]) => val !== null)
                    .map(([key, val]) => `${key}=${val}`)
                    .join("&");

                const response = await dataService.doctors.getAll(paramsString);
                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                commit('SET_ITEMS', response.data.doctors);
                commit('SET_TOTAL_ITEMS', response.data.totalItems);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async getAppointments(_, id) {
            startLoading()
            try {
                const response = await dataService.doctors.getAppointments(id);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }

                // commit('SET_Appointments', response.data.appointments);
                return Promise.resolve(response.data.doctor);

            } catch (error) {
                stopLoading()
                catchHandler(error);
            }
        },
        async addAppointments({ commit , getters}, { id, payload }) {
            startLoading()
            try {
                const response = await dataService.doctors.addAppointments(id, payload);

                stopLoading()
                if (!response.data.statusCode) {
                    showAlert(serverErrorMessage);
                    return;
                }
                showNotification(response.data.message);

                const index = getters.index(id);

                commit("UPDATE", { index, updateData: response.data.doctor });

            } catch (error) {
                stopLoading()
                catchHandler(error);
                return Promise.reject(error);
         
            }
        },
          async getDetails({ commit }, id) {
               try {
                   commit("SET_ITEM", {});
                   startLoading()
                   const response = await dataService.doctors.getDetails(id);
                   stopLoading()
       
                   if (!response.data.statusCode) {
                      showAlert(serverErrorMessage);
                      return;
                   }
                   commit("SET_ITEM", response.data.doctor);
               
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
               }
           },
         async add({ commit }, payload) {
               try {
                   startLoading()
                   const response = await dataService.doctors.add(payload);
                   stopLoading()
       
                   if (!response.data.statusCode) {
                      showAlert(serverErrorMessage);
                      return;
                   }
       
                   showNotification(response.data.message);
                   commit("add", response.data.doctor);
       
       
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
                   return Promise.reject(error);
               }
           },
         
           async getForEdit(_, id) {
               try {
                   startLoading()
                   const response = await dataService.doctors.getForEdit(id);
                   stopLoading()
       
                   if (!response.data.statusCode) {
                      showAlert(serverErrorMessage);
                      return;
                   }
       
                   return Promise.resolve(response.data.doctor);
               
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
               }
           },    async getDoctorServiceRates(_, id) {
               try {
                   startLoading()
                   const response = await dataService.doctors.getDoctorServiceRates(id);
                   stopLoading()
       
                   if (!response.data.statusCode) {
                      showAlert(serverErrorMessage);
                      return;
                   }
       
                   return Promise.resolve(response.data.doctor);
               
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
               }
           },
           async edit({ commit, getters }, { id, payload }) {
               try {
                   startLoading()
                   const response = await dataService.doctors.edit(id,payload);
                   stopLoading()
       
                   if (!response.data.statusCode) {
                      showAlert(serverErrorMessage);
                      return;
                   }
                   showNotification(response.data.message);

                   const index = getters.index(id);
                   commit("UPDATE", { index, updateData: response.data.doctor });
       
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
                   return Promise.reject(error);
               }
           },  async serviceManagement(_, { id, payload }) {
               try {
                   startLoading()
                   const response = await dataService.doctors.serviceManagement(id,payload);
                   stopLoading()
       
                   if (!response.data.statusCode) {
                      showAlert(serverErrorMessage);
                      return;
                   }
                   showNotification(response.data.message);

       
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
                   return Promise.reject(error);
               }
           },
           async delete({ commit, getters }, id) {
               try {
                   startLoading()
                   const response = await dataService.doctors.delete(id);
       
                   stopLoading()
       
                   if (!response.data.statusCode) {
                      showAlert(serverErrorMessage);
                      return;
                   }
       
                   showNotification(response.data.message);
                   const index = getters.index(id);
                   commit("DELETE", index);
               } catch (error) {
                   stopLoading()
                   catchHandler(error);
               }
           },
            async lock({ commit, getters }, id) {
                   try {
                       startLoading()
                       const response = await dataService.doctors.lock(id);
                       stopLoading()
           
                       if (!response.data.statusCode) {
                          showAlert(serverErrorMessage);
                          return;
                       }
           
                       showNotification(response.data.message);
           
           
                       const index = getters.index(id);
                       commit("lock", index);
                   } catch (error) {
                       stopLoading()
                       catchHandler(error);
                   }
               },
               async unlock({ commit, getters }, id) {
                   try {
                       startLoading()
                       const response = await dataService.doctors.unlock(id);
           
                       stopLoading()
           
                       if (!response.data.statusCode) {
                          showAlert(serverErrorMessage);
                          return;
                       }
           
                       showNotification(response.data.message);
           
                       const index = getters.index(id);
                       commit("unlock", index);
                   } catch (error) {
                       stopLoading()
                       catchHandler(error);
                   }
               },
    },
};
